import { useState, FormEvent } from "react";
import { supabase } from "../../../lib/supabase";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !name) {
      setError("Por favor completa todos los campos.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const { error: supaError } = await supabase
        .from("newsletter_subscribers")
        .insert([{ email, name }]);

      if (supaError) {
        if (supaError.message.includes("duplicate")) {
          setError("Este correo ya está suscrito al newsletter.");
          setLoading(false);
          return;
        }
        throw supaError;
      }

      try {
        await supabase.functions.invoke("send-welcome-email", {
          body: { email, name },
        });
      } catch (emailErr) {
        console.error("Error sending welcome email:", emailErr);
      }

      setSubmitted(true);
    } catch {
      setError("Error de conexión. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="bg-[#2563EB] py-6 md:py-12 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-white/5" />
      <div className="absolute -right-20 top-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-white/5" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-white/10" />

      <div className="max-w-2xl mx-auto px-4 md:px-6 relative z-10 text-center">
        <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mx-auto mb-5">
          <i className="ri-mail-send-line text-white text-2xl" />
        </div>
        <h2 className="text-white font-bold mb-3" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "clamp(1.8rem, 4vw, 2.5rem)" }}>
          MANTENTE INFORMADO
        </h2>
        <p className="text-white/70 font-inter text-base mb-8">
          Recibe noticias del sector aeronáutico directamente en tu correo. Contenido exclusivo sobre aviación en República Dominicana y el Caribe.
        </p>

        {submitted ? (
          <div className="bg-white rounded-xl px-8 py-8 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB] rounded-full mx-auto mb-4">
              <i className="ri-check-line text-white text-xl" />
            </div>
            <p className="text-[#1e3a5f] font-bold text-lg font-inter">¡Suscripción exitosa!</p>
            <p className="text-slate-500 text-sm font-inter mt-2">
              Pronto recibirás las últimas noticias del sector aeronáutico dominicano.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20"
          >
            <div className="flex flex-col sm:flex-row gap-3 mb-3">
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Tu nombre"
                className="flex-1 px-4 py-3 rounded-lg bg-white text-slate-800 placeholder-slate-400 text-sm font-inter focus:outline-none focus:ring-2 focus:ring-white/50 border border-white/20"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Tu correo electrónico"
                className="flex-1 px-4 py-3 rounded-lg bg-white text-slate-800 placeholder-slate-400 text-sm font-inter focus:outline-none focus:ring-2 focus:ring-white/50 border border-white/20"
              />
            </div>
            {error && (
              <p className="text-red-200 text-xs font-inter mb-3 text-left">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-white hover:bg-slate-100 text-[#2563EB] font-inter font-semibold text-sm rounded-lg transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin" /> Enviando...
                </span>
              ) : (
                <>
                  <i className="ri-send-plane-line mr-2" /> Suscribirme al Newsletter
                </>
              )}
            </button>
            <p className="text-white/50 text-xs font-inter mt-3">
              Sin spam. Solo noticias del sector aeronáutico. Cancela cuando quieras.
            </p>
          </form>
        )}
      </div>
    </section>
  );
}